<template>
    <div class="body-small-bold flex items-center justify-center">
        <div
            v-if="currentStepDisplay"
            role="progressbar"
            :aria-label="t('onboarding.progress.label')"
            :aria-valuenow="STEP_ORDER[currentStep]"
            aria-valuemin="1"
            aria-valuemax="3"
            :aria-valuetext="currentStepDisplay"
            class="border-2 border-border rounded-full px-6 py-3 bg-surface-raised flex">
            <div class="flex gap-1 items-center py-2 md:py-[unset]">
                <div v-for="step in 3" :key="step" class="h-2 rounded-full relative w-10 bg-progress-track" :style="{ width: `${BAR_WIDTH}px` }">
                    <div class="absolute h-2 rounded-full bg-progress-fill transition-[width]" :style="{ width: currentProgressWidth(step) }"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const BAR_WIDTH = 40;

const { currentStep, steps, questionIndex, isAnswered } = defineProps({
    currentStep: { type: String, required: true },
    steps: { type: Object, required: true },
    questionIndex: { type: Number, required: true },
    isAnswered: { type: Boolean, default: false },
});

const STEP_ORDER = { [steps.PERSONALIZATION]: 1, [steps.GREETING]: 1, [steps.PATH_SELECTION]: 1, [steps.QUESTIONS]: 2, [steps.INSIGHTS]: 3 };

const currentProgressWidth = (step) => {
    if (STEP_ORDER[currentStep] > step) {
        return `${BAR_WIDTH}px`;
    }
    if (STEP_ORDER[currentStep] === step) {
        if (currentStep === steps.GREETING) {
            return `${BAR_WIDTH}px`;
        }
        if (currentStep === steps.QUESTIONS) {
            if (questionIndex === 0) {
                return isAnswered ? `${BAR_WIDTH / 2}px` : `${BAR_WIDTH / 5}px`;
            }
            return isAnswered ? `${BAR_WIDTH}px` : `${BAR_WIDTH / 2}px`;
        }
        return `${BAR_WIDTH / 2}px`;
    }
    return undefined;
};

const currentStepDisplay = computed(() => {
    switch (currentStep) {
        case steps.PERSONALIZATION:
        case steps.GREETING:
            return t("onboarding.progress.meetNadia");
        case steps.PATH_SELECTION:
            return t("onboarding.progress.choosePath");
        case steps.QUESTIONS:
            return t("onboarding.progress.aboutYou");
        case steps.INSIGHTS:
            return t("onboarding.progress.insights");
        default:
            return undefined;
    }
});
</script>
